import { useFlag } from '@unleash/proxy-client-vue';
import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import authorization from '@rygen/rygen-ui/authorization';

import { RateQuote } from '@/model';

export interface UseDoNotDispatchResponse {
  canOverrideCarrierDoNotDispatch: ComputedRef<boolean>;
  isDoNotDispatchEnabled: ComputedRef<boolean>;
  isRateQuoteDispatchable: (rateQuote: RateQuote | undefined) => boolean;
}

export const useDoNotDispatch = (): UseDoNotDispatchResponse => {
  const _isDoNotDispatchEnabled = useFlag('doNotDispatch');

  const isDoNotDispatchEnabled = computed(() => _isDoNotDispatchEnabled.value);
  const canOverrideCarrierDoNotDispatch = computed(() =>
    authorization.hasAuthority('client', 'overrideCarrierDoNotDispatch'),
  );

  const isRateQuoteDispatchable = (
    rateQuote: RateQuote | undefined,
  ): boolean => {
    if (!isDoNotDispatchEnabled.value) {
      return true;
    }

    return (
      !!rateQuote &&
      (!rateQuote.doNotDispatch || canOverrideCarrierDoNotDispatch.value)
    );
  };

  return {
    canOverrideCarrierDoNotDispatch,
    isDoNotDispatchEnabled,
    isRateQuoteDispatchable,
  };
};
